import React from 'react';
import ContentPage from '../ContentPage/ContentPage';
import ContactForm from 'View/Component/ContactForm/ContactForm';

const ContactPage: React.FC = () => (
  <ContentPage slug="kontakt" title="Kontakt">
    <ContactForm />
  </ContentPage>
);

export default ContactPage;
